<template>
    <div>
        <base-dialog @close="close" :open="show" newClass="w3-modal-content w3-card-4 ">
            <template #default>
                <div class="w3-container" id="related-items-container">
                    <!-- <span @click="close" class="w3-button w3-display-topright">×</span> -->
                    
                    <!--WHI RELATED PART TYPES-->		  
                    <div class="container">	
                        <div class="block-space--layout--divider-20"></div>
                        <div class="block-space--layout--divider-20"></div>
                        <div class="products-view__list products-list products-list--grid--4" data-layout="table" data-with-features="false">

                            <base-message
                            v-if="servermessages.length > 0"
                            :servermessages="servermessages"
                            ></base-message>
                            
                            <div class="products-list__head">
                                <div class="products-list__column products-list__column--image">Image</div>
                                <div class="products-list__column products-list__column--qty">Qty</div>	 
                                <div class="products-list__column products-list__column--product">Product</div>
                                <div class="products-list__column products-list__column--information" v-if="storeCatalog.toUpperCase() == 'WHI'">Information</div>
                                <div class="products-list__column products-list__column--availability">Availability</div>
                                <div class="products-list__column products-list__column--price">Price</div>							   
                            </div>

                            <div class="products-list__content" v-if="related_items.length > 0">
                                <div class="products-list__item" v-for="(item, indx) in related_items" :key="indx">
                                    <div class="product-card">
                                        <div class="product-card__image">
                                            <div class="image image--type--product modal-thumbnail">  
                                                <a href="#" class="image__body">
                                                    <img class="image__tag" :src="item.QITTMB">
                                                </a>															
                                            </div>
                                        </div>
                                        <div class="cart-table__quantity-search-results  product-card__stock-text-search-whi-product-qty">
                                            <!-- <div class="cart-table__quantity input-number">
                                                <input class="form-control-order-entry-qty-selector input-number__input" type="number" min="1" value="1" data-title="Quantity">
                                                <div class="input-number__add"></div>
                                                <div class="input-number__sub"></div>
                                            </div> -->
                                            <base-quantity-input v-model="item.quantity"></base-quantity-input>
                                        </div>
                                        <a href="#" class="product-card__addtocart-icon product-card__addtocart-icon-whi product-card__stock-text-search-whi-product-btn-cart" type="button" aria-label="Add to cart" @click="addToCart(item)">
                                            <svg width="20" height="20">
                                                <circle cx="7" cy="17" r="2"></circle>
                                                <circle cx="15" cy="17" r="2"></circle>
                                                <path d="M20,4.4V5l-1.8,6.3c-0.1,0.4-0.5,0.7-1,0.7H6.7c-0.4,0-0.8-0.3-1-0.7L3.3,3.9C3.1,3.3,2.6,3,2.1,3H0.4C0.2,3,0,2.8,0,2.6
V1.4C0,1.2,0.2,1,0.4,1h2.5c1,0,1.8,0.6,2.1,1.6L5.1,3l2.3,6.8c0,0.1,0.2,0.2,0.3,0.2h8.6c0.1,0,0.3-0.1,0.3-0.2l1.3-4.4
C17.9,5.2,17.7,5,17.5,5H9.4C9.2,5,9,4.8,9,4.6V3.4C9,3.2,9.2,3,9.4,3h9.2C19.4,3,20,3.6,20,4.4z"></path>
                                            </svg>
                                        </a>																			 
                                        <button class="product-card__addtocart-full" type="button" @click="addToCart(item)">
                                            Add to cart
                                        </button>
                                        
                                        <div class="product-card__info">                                                        
                                            <div class="product-card__name">
                                                <div class="product-card__badges"></div>
                                                <div>
                                                    <a href="#" @click="setWHIProduct(item)" class="cart-table__product-name">{{item.item_description}}</a><br>										
                                                    <div class="text-cart-item-number"><font class="text-cart-item-number">Item: {{item.sku}}</font></div> 			
                                                    <div class="text-cart-item-manufacturer"><font class="text-cart-item-manufacturer">Manufacturer: {{item.manufacturerdesc}}</font></div>
                                                    <!-- <div class="block-brands__item-alternates-available"><a href="#"> View Alternate Products</a></div> -->
                                                </div>
                                            </div>
                                            <div class="product-card__information" v-if="storeCatalog.toUpperCase() == 'WHI'">														
                                                <ul class="search-results--bullets">
                                                    <li v-if="item.smartpage_url != ''">
                                                        <a href="#" id="link" @click="$emit('open-smart-page', item.smartpage_url);close();">Smart Page</a>
                                                    </li>
                                                    <li>
                                                        <router-link class="search-results--links" :to="'/interchange/' + item.sku">Interchange</router-link>
                                                    </li>
                                                    <li>
                                                        <router-link class="search-results--links" :to="'/buyers-guide/' + item.QMFRCD + '/' + item.QITEMC + '/' + item.QTYPEC ">Buyer's Guide</router-link>
                                                    </li>
                                                    <li>
                                                        <a class="search-results--links" @click="$emit('open-related-type', item);close();">Related</a>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="product-card__availability">
                                                <div class="block-brands__item-stock-available"></div>
                                            </div>
                                            <div class="product-card__check-stock">
                                                <div class="block-brands__item-check-stock">
                                                    <div class="btn-check-stock" v-if="showCheckStock">
                                                        <router-link :to="'/order-entry-check-stock/' + item.QMFRCD + '/' + item.QITEMC" class="btn btn-micro btn-dark-grey btn-check-stock" v-if="showCheckStock">Check Stock</router-link>
                                                    </div>
                                                    <product-stock-display :stock-quantity="item.stockquantity" />
                                                </div>
                                            </div>
                                        </div>

                                        <div class="product-card__footer">
                                            <div class="product-card__prices">
                                                <div class="product-card__price product-card__price--current">Price: 
                                                    <span class="notranslate">
                                                        {{toUSD(item.extended_price)}}
                                                    </span>
                                                </div>
                                                <div class="product-card__price product-card__price--old" v-if="item.list_price > 0">List: <span class="notranslate">{{toUSD(item.list_price)}}</span></div>
                                                <!--<div class="product-card__price product-card__price--core">Core: $1.00</div>-->
                                            </div>				                                                        
                                            
                                        </div>
                                    </div>
                                </div>                                                                    
                            </div>
                            <div class="products-list__content noscroll" v-else>
                                <div class="products-list__item">
                                    No Related Items
                                </div>
                            </div>
                        </div>
                        <div class="block-space--layout--divider-20"></div>
                    </div>
                    
                </div>

            </template>

            <template #actions>
                <div class="w3-container w3-border-top w3-padding-16 w3-light-grey buttons">
                    
                </div>
            </template>
        </base-dialog>
    </div>
</template>

<script>
    import Price from '../../../mixins/price.js';
    import MixinCart from '../../../mixins/cart.js';
    import axiosvl from "../../../axios/axios-vl.js";
    import { mapGetters } from 'vuex';
    import * as GCONST from "../../../constants.js";
    import ProductStockDisplay from '../../common/product/ProductStockDisplay.vue';
    import CloudinaryApi from '../../../utilities/cloudinaryapi';

    export default {
        components: {
          "product-stock-display": ProductStockDisplay,
        //   "add-to-cart-dialog" : AddToCartDialog
        },
        data() {
            return {
                // prod
                type: '',
                product : {},
                related_items: [],
                show: false,
                servermessages: [],
            };
        },
        mixins: [Price, MixinCart],
        computed: {
            ...mapGetters([
                'storeCatalog', 
                'customerIndicator',
                'storefrontAttributes'
            ]),
            ...mapGetters("message", [
                "sharedmessages",
                "sharedmessagestatus"
            ]),
            showCheckStock() {
                if (this.storefrontAttributes.length > 0) {
                    let onHandQuantityRule = this.storefrontAttributes.find(attribute => attribute.indicator === this.customerIndicator && attribute.type === 'OHQ').value;
                    return this.customerIndicator === 'B' && onHandQuantityRule != '5';
                } else {
                    return false;
                }
            },
        },

        props: {
            // product : {
            //     type : Object,
            //     required: true
            // },
        },

        methods: {
            close() {
                this.$emit('close');
                this.show = false;
            },
            
            /** whi related items */
            getRelatedItems(product, type) {
                // console.log('type = ' + type);
                this.type = type;
                this.product = product;
                this.show = true;
                this.related_items = [];
                this.isloading = true;
                const related_items_uri = this.$store.getters['api/related_items_uri'];
                // const catpn = (this.storeCatalog.toUpperCase() == 'WHI') ? '003' : '002';
                const catpn = this.$store.getters['storeConfigID'];
                const params = {
                    "webroutine": {
                        "context": {
                            "session-key-method": "hidden"
                        },
                        "fields": {
                            "EHCUST": { "value": this.$store.getters.customer },
                            "CATPN": {"value": catpn },
                            "QYEAR": {"value": this.$store.getters['vehicle/selectedyear'] },
                            "QMAKE": {"value": this.$store.getters['vehicle/selectedmake'].selectedmake },
                            "QMODEL": {"value": this.$store.getters['vehicle/selectedmodel'].selectedmodel },
                            "QCARCD": {"value": this.$store.getters['vehicle/selectedengine'].selectedengine },
                            "QTYPEC": {"value": this.product.QTYPEC },
                            "USG": {"value": this.product.QIGSEQ },
                            "QMFRCD": {"value": this.product.manufacturer },
                            "QITEMC": {"value": this.product.QITEMC },
                            "QCTYP": {"value": type }
                        }
                    }
                }
                axiosvl.post(related_items_uri, params)
                .then((response) => {
                    const lists = response.data.webroutine.lists;
                    const PARTS = lists.PARTS.entries;
                    const ETXLIST = lists.ETXLIST.entries;
                    this.parts_desc = ETXLIST;
                    PARTS.forEach(obj => {
                        // opt.stockquantity = (this.$store.getters.customerIndicator == 'B') ? opt.QOHAND : opt.TOTOH;
                        // this.related_items.push(opt);
                        this.related_items.push({
                            quantity : 0,
                            manufacturer: obj.QMFR,
                            manufacturerdesc: obj.QMFDSC,
                            sku: obj.QITEMNUM,
                            item_description: obj.QITDSC,
                            QLIST: obj.QLIST,
                            QCORE: obj.QCORE,
                            extended_price: obj.QSELL,
                            // stockquantity: obj.QOHAND,
                            stockquantity: (this.$store.getters.customerIndicator == 'B') ? obj.QTYAVL : obj.TOTOH,
                            availability: obj.QTYAVL,
                            list_price: obj.QLISTN,
                            core_charge: obj.QCOREN,
                            QTDESC: obj.QTDESC,
                            QSCORE: obj.QSCORE,
                            QSCOREN: obj.QSCOREN,
                            EKSIZE: obj.EKSIZE,
                            QSIZE: obj.QSIZE,  
                            QITEMSZ: obj.QITEMSZ,
                            CUFLAG: obj.CUFLAG,  
                            QLISTNC: obj.QLISTNC,
                            QITSEQ: obj.QITSEQ,  
                            QITTXT: obj.QITTXT,
                            use_description: obj.QITUSE,                                
                            quantity_per_car: obj.QITPCQ,   
                            years: obj.QIPYRS,   
                            QICSEQ: obj.QICSEQ,   
                            QIGSEQ: obj.QIGSEQ,   
                            QIGDSC: obj.QIGDSC,
                            image: (obj.EPIMG) ? obj.EPIMG : GCONST.THUMB_IMAGE_PLACEHOLDER,
                            QIMTAG: obj.QIMTAG,
                            QICON: obj.QICON,
                            catalog_part_number: obj.QICPN,
                            CLTYPE: obj.CLTYPE,
                            DEDESC: obj.DEDESC,
                            MCNAME: obj.MCNAME,
                            smartpage_url: obj.QITURL,
                            TOTOH: obj.TOTOH,
                            PARTN: obj.PARTN,
                            SHOWMTP: obj.SHOWMTP,
                            QITIMG: obj.QITIMG,
                            QITTMB: obj.QITTMB,
                            QTYPEC: obj.QTYPEC,
                            QMFRCD: obj.QMFRCD,
                            QITEMC: obj.QITEMC,
                            txt_list: this.parts_desc.filter(i => i.ETXITM == obj.QITEMNUM)
                        });
                    });

                    // console.log(this.related_items);
                    this.isloading = false;
                })
                .catch((error) => {
                    console.log("error - " + error);
                    this.isloading = false;
                });
            },

            setWHIProduct(item) {

                if(this.storeCatalog.toUpperCase() == 'WHI'){
                    this.$store.dispatch("product/setWhi_product", item);
                    this.$router.push('/whi-product-detail');
                }

                if(this.storeCatalog.toUpperCase() == 'PARTSLINK'){
                    this.$router.push('/part/' + item.manufacturer + '/' + item.sku);
                }
            },

            addToCart(product) {
                this.$store.dispatch("message/clearKeyedMessage", this.sourcePage);
                let linetotal = 0;
    
                // if (this.$store.getters.customer != 'B2C') {
                //   linetotal = this.quantity * this.product.extended_price;
                // } else {
                linetotal = product.quantity * this.product.extended_price;
                const defaultLoc = this.$store.getters.getCustomerDetails;
                // }
                // console.log(this.product);

                let productData = {
                    ID: product.sku,
                    item: product.sku,
                    desc: product.item_description,
                    manufacturer: product.manufacturer,
                    image: product.QITTMB,
                    quantity: product.quantity,
                    listprice: product.list_price,
                    corecharge: product.core_charge,
                    yourprice: product.extended_price,
                    shipping: 0,
                    linetotal: linetotal,

                    // new fields
                    XRMFGC: product.XRMFGC,
                    XRITMC: product.XRITMC,
                    IMIGSA: product.IMIGSA,
                    IMISVALID: product.IMISVALID,
                    
                    stockquantity: product.stockquantity,
                    locationid: product.location,
                    locationname: defaultLoc.defaultlocationname,
                    locationcity: defaultLoc.defaultlocationcity,
                    locationstate: defaultLoc.defaultlocationstate,
                };
                
                let validationresult = this.addToCartValidation(productData);
                // validationresult.status = 'OK';
                // console.log(validationresult);
                if (validationresult.status === 'OK') {
                    this.$store.dispatch("cart/addToCart", productData);

                    this.added_to_cart = {
                        item_name: product.manufacturer + ' ' + product.item_description + ' ' + product.sku,
                        quantity : product.quantity,
                        item_image: product.QITTMB,
                    }

                    this.hasAdded = true;
                } else {
                  this.servermessages = [];
                  this.servermessages.push(validationresult.message);
    
                //   this.$store.dispatch("message/addKeyedMessage", {
                //     "key": this.sourcePage,
                //     "messages": storedmessages
                //   });
                }
                
            },

            /** partslink relatd items */
            getPartRelated(product) {
                this.product = product;
                this.show = true;
                const manufacturer  = product.manufacturer;
                const itemsku  = product.QITEMC;
                this.related_items = [];

                // console.log(image);
                axiosvl.post(this.$store.getters['api/related_parts_uri'], {
                    "webroutine": {
                        "context": {
                            "session-key-method": "hidden"
                        },   
                        "fields": {
                            "EHCUST": { "value": this.$store.getters['customer'] },
                            "EIMFGC": { "value": manufacturer },
                            "EIITMC": { "value": itemsku },
                        },   
                    }
                })
                .then((response) => {
                    const fields = response.data.webroutine.fields;
                    const RPARTS = response.data.webroutine.lists.RPARTS.entries;
                    // const PARTLOC = response.data.webroutine.lists.PARTLOC.entries;
                    // const defaultLoc = this.$store.getters.getCustomerDetails;
                    // const wd_mdfgs = this.$store.getters.wd_mfgs;
                    
                    if (fields.RESULTCOD.value === 'OK') {
                        RPARTS.forEach(obj => {
                            // this.related_items.push(obj);
                            
                            this.related_items.push({
                                quantity : 0,
                                manufacturer: obj.DMMFGC,
                                manufacturerdesc: '',
                                sku: obj.IUDATA,
                                description: obj.IMDESC,
                                QLIST: obj.QLIST,
                                QCORE: obj.QCORE,
                                extended_price: obj.PRC,
                                availability: obj.EIOQTY,
                                list_price: obj.EILSTP,
                                core_charge: obj.CORP,
                                QTDESC: obj.QTDESC,
                                QSCORE: obj.QSCORE,
                                QSCOREN: obj.QSCOREN,
                                EKSIZE: obj.EKSIZE,
                                QSIZE: obj.QSIZE,  
                                QITEMSZ: obj.QITEMSZ,
                                CUFLAG: obj.CUFLAG,  
                                QLISTNC: obj.QLISTNC,
                                QITSEQ: obj.QITSEQ,  
                                QITTXT: obj.QITTXT,
                                use_description: obj.QITUSE,                                
                                quantity_per_car: obj.QITPCQ,   
                                years: obj.QIPYRS,   
                                QICSEQ: obj.QICSEQ,   
                                QIGSEQ: obj.QIGSEQ,   
                                QIGDSC: obj.QIGDSC,
                                image: (obj.EPIMG) ? obj.EPIMG : GCONST.THUMB_IMAGE_PLACEHOLDER,
                                QIMTAG: obj.QIMTAG,
                                QICON: obj.QICON,
                                catalog_part_number: obj.QICPN,
                                CLTYPE: obj.CLTYPE,
                                DEDESC: obj.DEDESC,
                                MCNAME: obj.MCNAME,
                                smartpage_url: obj.QITURL,
                                TOTOH: obj.TOTOH,
                                PARTN: obj.PARTN,
                                SHOWMTP: obj.SHOWMTP,
                                QITIMG: obj.QITIMG,
                                QITTMB: (obj.QITTMB) ? obj.QITTMB : GCONST.THUMB_IMAGE_PLACEHOLDER,
                                QTYPEC: obj.QTYPEC,
                                QMFRCD: obj.DMMFGC,
                                QITEMC: obj.IUDATA,
                                // txt_list: this.parts_desc.filter(i => i.ETXITM == obj.QITEMNUM)
                            });
                        });

                        this.related_items.forEach((item, i) => {
                            this.getProductDetails(item, i);
                        })
                    }else{
                        this.isloading = false;
                    }
                })
                .catch((error) => {
                    console.log("error - " + error);
                });
            },


            // get product details from the web service
            async getProductDetails(product, i){
                await axiosvl.post(this.$store.getters['api/product_details_uri'], {
                    "webroutine": {
                        "context": {
                            "session-key-method": "hidden"
                        },   
                        "fields": {
                            "EHCUST": { "value": this.$store.getters['customer'] },
                            "EIMFGC": { "value": product.manufacturer },
                            "EIITMC": { "value": product.sku },
                        },   
                    }
                })
                .then((response) => {
                    const fields = response.data.webroutine.fields;
                    const lists = response.data.webroutine.lists;
                    if (fields.RESULTCOD.value === 'OK') {
                        // console.log(fields);
                        // const linetotal = 1 * fields.EIEXCP.value;
                        const defaultLoc = this.$store.getters.getCustomerDetails;
                        const clearProductDesc = encodeURIComponent(product.description);
                        const DDTXT = lists.DDTXT;
                        let prod_desc = '';

                        DDTXT.entries.forEach(d => {
                            prod_desc += d.DDTXT1 + d.DDTXT2 + d.DDTXT3 + d.DDTXT4 + d.DDTXT5 + d.DDTXT6 + d.DDTXT7 + d.DDTXT8 + d.DDTXT9 + d.DDTXT0;
                        });
                        
                        this.related_items[i] = {
                            manufacturer: product.manufacturer,
                            sku: fields.IMITMC.value,
                            // customer: obj.CMCUST,
                            location: defaultLoc,
                            IMMFGC: product.manufacturer,
                            manufacturerdesc: fields.MCNAME.value,
                            IMITMC: fields.IMITMC.value,
                            item_description: fields.IMDESC.value,
                            full_description: prod_desc,
                            XRMFGC: '',
                            XRITMC: '',
                            DEDESC: '',
                            IMIGSA: fields.IMIGSA.value,
                            IMISVALID: '',
                            mfgSeo: product.manufacturerdesc.replace(/ /g, "-"),
                            itemSeo: clearProductDesc.replace(/ /g, "-"),
                            image: product.QITTMB,
                            // from Nic @ issue #260
                            // if it is B2B use QTYAVL
                            // if it is B2C use TOTOH
                            stockquantity: (this.$store.getters.customerIndicator == 'B') ? fields.QTYAVL.value : fields.TOTOH.value,
                            // stockquantity: 1,
                            // stockqty: 1,
                            list_price: fields.EILSTP.value,
                            extended_price: fields.EIEXCP.value,
                            core_charge: fields.EICORP.value,
                            HASSUBST: fields.HASSUBST.value,

                            QMFRCD: product.QMFRCD,
                            QITEMC: product.QITEMC,
                        };

                        console.log(this.related_items[i]);

                        const clApi = new CloudinaryApi;
                        clApi.item_sku = product.sku;
                        clApi.manufacturer_code = product.manufacturer;
                        
                        clApi.vlImageByMeta(GCONST.CL_METARTYPE_PARTSLINK, GCONST.Product_Thumbnail).then(imgURL => {
                            if(imgURL){
                                this.related_items[i].QITTMB = imgURL;
                            }else{
                                this.related_items[i].QITTMB = GCONST.IMAGE_PLACEHOLDER;
                            }
                        });
                    }else{
                        this.isloading = false;
                    }
                })
                .catch((error) => {
                    console.log("error - " + error);
                });
            },
        },

        watch: {
            sharedmessagestatus(newVal) {
                if (newVal === 'complete') {
                    // This indicates that messages were stored on the state
                    let msgs = this.$store.getters['message/sharedmessages']

                    if (msgs["SearchResults"] != undefined) {
                        this.servermessages = msgs["SearchResults"];
                    }

                }
                this.$store.dispatch("message/resetStatus");

            },
        },

        created() {
            this.servermessages = [];
            // console.log('RelatedPartTypes - created');
            // this.getRelatedTypes();
        }
    }
</script>

<style scoped>
    .buttons {
        width: 100%;
    }

    #related-items-container {
        max-height: 600px;
    }

    .products-list__content {
        max-height: 500px;
        overflow-y: visible;
    }
    .products-list__content.noscroll{
        overflow: hidden !important;
    }
</style>